import { render, staticRenderFns } from "./BnAddressGap.vue?vue&type=template&id=66f47522&"
import script from "./BnAddressGap.vue?vue&type=script&lang=js&"
export * from "./BnAddressGap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports